import { Spinner } from '@blueprintjs/core';
import React, { Component } from 'react';
class SmallSpinner extends Component {
	render() { 
		return <Spinner className="pt-small"/>
	}
}

export default SmallSpinner;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/SmallSpinner.js